module.exports = __webpack_public_path__ + "static/img/7.9054e277.jpg";